module.exports = __webpack_public_path__ + "resource/img/image009Dark.23d0d279.png";